import { GenreCategoryOut } from '../../../../../store/apiLibx';
import { InputDropdownOptions } from '../../../shared/LCFormFieldInputDropdown';

export const mapGenreCategory = (
    genreCategory: GenreCategoryOut | undefined,
    categories: { key: string; value: string }[]
): InputDropdownOptions<string> => {
    return { current: genreCategory?.id, all: categories };
};
